import React from 'react';
import classnames from 'classnames';
import Comments from '../Comments';
import BackToStreamButton from '../BackToStreamButton';
import Details from '../../../DeviationViews/Details';
import Sidebar from '../../../Sidebar';
import ActionBar from '../../../ActionBar';
import CentralColumn from '../CentralColumn';
import ArtStage from '../../../ArtStage';
import LoadingIndicator from '../../../LoadingIndicator';
import s from './SimplePage.scss';
export var SimplePage = function (_a) {
    var _b = _a.withSidebar, withSidebar = _b === void 0 ? true : _b, deviation = _a.deviation;
    var isExtendedLoaded = !!deviation.extended;
    return (React.createElement("div", { className: classnames(s['root'], withSidebar && s['sidebar']) },
        React.createElement("div", { className: s['left-column'] },
            React.createElement(ArtStage, { deviation: deviation }),
            React.createElement(BackToStreamButton, { deviation: deviation }),
            React.createElement(ActionBar, { deviation: deviation }),
            React.createElement(CentralColumn, null,
                React.createElement(Details, { deviation: deviation }),
                isExtendedLoaded && (React.createElement(Comments, { deviation: deviation, className: s['comments'] })),
                !isExtendedLoaded && (React.createElement(LoadingIndicator, { className: s['lloader'], view: "llama" })))),
        withSidebar && (React.createElement(Sidebar, { deviation: deviation, className: s['right-column'] }))));
};
SimplePage.displayName = 'SimplePage';
export default SimplePage;
//# sourceMappingURL=SimplePage.js.map